module.exports = __webpack_public_path__ + "static/media/Sju-min.76152931.PNG";